import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import logo from "../../../assets/images/karak_logo_new.png";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Progress,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import {
  convertToLowestUnit,
  ExportAvailableInCSVForReports,
  exportFromula,
  formatUnitsForReport,
  GetUpdatedDelivered,
  mapUnits,
} from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import preloader from "../../../helpers/preloader";
import showNotification from "../../../helpers/show_notification";
import {
  columnsItemInbound,
  columnsItemInboundDetails,
  columnsItemOutbound,
  columnsItemOutboundDetails,
  columnsProductInbound,
  columnsProductInboundDetails,
  columnsProductOutbound,
  columnsProductOutboundDetails,
} from "./BranchwiseSummaryColumns";
import {
  mergeDuplicateItems,
  mergeDuplicateItemsQuantity,
  mergeDuplicateProdQuantity,
  mergeDuplicateProducts,
} from "../../../helpers/commonFunctions";

const BranchwiseSummaryReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();

  const [selectedRow, setSelectedRow] = useState([]);
  const [allBranches, setAllBranches] = useState([]);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    loadAllBranches();
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
    }
  }, [dateFrom, dateTo]);

  function afterFilterForDetails(
    newData,
    quantityField,
    detailsType = "delivery_details",
  ) {
    const data = newData;
    let totalCost = 0;
    let totalLowestUnitQty = 0;

    data.forEach((item) => {
      const details = item[detailsType];
      const {
        receiving_cost = 0,
        cost = 0,
        unit_levels,
        received_quantity,
        receive,
        quantity,
      } = details || {};

      totalCost += Number(receiving_cost || cost || 0);

      if (unit_levels) {
        const quantityToBeDisplayed =
          quantityField === "received_quantity"
            ? received_quantity
            : quantityField === "receive"
              ? receive
              : quantity;

        if (quantityToBeDisplayed) {
          const convertedQty = convertToLowestUnit(
            unit_levels,
            quantityToBeDisplayed,
          );
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      }
    });

    let displayQuantity = "";
    const firstItemDetails = data[0]?.[detailsType];
    if (firstItemDetails?.unit_levels) {
      const { unit_levels } = firstItemDetails;
      const lowestUnit = unit_levels.at(-1).unit;

      const summedQuantity = [
        {
          unit: lowestUnit,
          value: totalLowestUnitQty,
        },
      ];

      displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
    }
    setFilterModalTotalQty(displayQuantity);
    setFilterModalSubTotal(totalCost.toFixed(2));
  }

  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter(
        (store) => store.type !== "EQUIPMENT STORE" && store.is_active === true,
      );
      const sorted = res.sort((a, b) => a.name.localeCompare(b.name));
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allOrders, setAllOrders] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const BATCH_SIZE = 8;

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const days_diff = moment(dateTo).diff(dateFrom, "days");
      if (days_diff > 31) {
        setFilteredOrders([]);
        setGrandTotal(0);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (days_diff < 0) {
        setFilteredOrders([]);
        setGrandTotal(0);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      const branchIds = allBranches.map((branch) => branch._id);
      if (!branchIds.length) {
        showNotification(
          "Branches are still loading. Please try again.",
          "Error",
        );
        return false;
      }

      setIsLoading(true);
      setProgress(0);
      setAllOrders([]);
      setGrandTotal(0);
      setFilteredOrders([]);

      const date_from = moment(dateFrom).format("YYYY-MM-DD");
      const date_to = moment(dateTo).format("YYYY-MM-DD");
      const url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary";
      const totalBatches = Math.ceil(branchIds.length / BATCH_SIZE) || 1;
      let mergedData = [];
      let grandTotalCost = 0;

      for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
        if (requestId !== ordersRequestId.current) return;
        const batchBranchIds = branchIds.slice(i, i + BATCH_SIZE);
        const batchResponse = await postSubmitForm(url, {
          date_from,
          date_to,
          branch_ids: batchBranchIds,
        });
        if (requestId !== ordersRequestId.current) return;

        if (batchResponse && batchResponse.status === 1) {
          mergedData = mergedData.concat(batchResponse.data.branches || []);
          grandTotalCost += Number(batchResponse.data.grand_total_cost) || 0;
          setAllOrders(mergedData);
          setGrandTotal(grandTotalCost);
        }

        const currentBatch = Math.floor(i / BATCH_SIZE) + 1;
        setProgress(Math.round((currentBatch / totalBatches) * 100));
      }

      if (requestId !== ordersRequestId.current) return;
      setAllOrders(mergedData);
      setGrandTotal(Number(grandTotalCost));
      setTablePage(1);
      setProgress(100);
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.error("Error loading orders:", error);
      showNotification("Error loading data", "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoading(false);
      }
    }
  };
  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [directPurchaseDetails, setDirectPurchaseDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [itemOutboundDetails, setItemOutboundDetails] = useState([]);
  const [itemInboundDetails, setItemInboundDetails] = useState([]);
  const [productOutboundDetails, setProductOutboundDetails] = useState([]);
  const [productInboundDetails, setProductInboundDetails] = useState([]);

  const loadPurchaseDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_po";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { delivery_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            receive,
          } = delivery_details || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && receive) {
            const convertedQty = convertToLowestUnit(unit_levels, receive);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setPurchaseDetails(response.data);
        setPurchaseDetailsModal(!purchaseDetailsModal);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadDirectPurchaseDetails = async (item_id) => {
    try {
      preloader(true);

      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_direct_po";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        preloader(false);
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { delivery_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            receive,
          } = delivery_details || {};

          // Add receiving cost
          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && receive) {
            const convertedQty = convertToLowestUnit(unit_levels, receive);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        // Get display quantity if possible
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setDirectPurchaseDetails(response.data);
        setDirectPurchaseDetailsModal(!directPurchaseDetailsModal);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadItemDetails = async (item_id) => {
    try {
      preloader(true);

      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_item_orders";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { delivery_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            received_quantity,
          } = delivery_details || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && received_quantity) {
            const convertedQty = convertToLowestUnit(
              unit_levels,
              received_quantity,
            );
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setItemDetails(response.data);
        setItemDetailsModal(!itemDetailsModal);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadProductDetails = async (product_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_orders";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: product_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { delivery_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            received_quantity,
          } = delivery_details || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && received_quantity) {
            const convertedQty = convertToLowestUnit(
              unit_levels,
              received_quantity,
            );
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductDetails(response.data);
        setProductDetailsModal(!productDetailsModal);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadItemOutboundDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_item_transfers_outbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { item_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            quantity,
          } = item_details || {};

          // Add receiving cost
          totalReceivingCost += Number(receiving_cost);

          // Convert and add quantity if both unit_levels and quantity exist
          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.item_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setItemOutboundDetails(response.data);
        setItemOutboundDetailsModal(true);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadItemInboundDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_item_transfers_inbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        item_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { item_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            quantity,
          } = item_details || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        // Get display quantity if possible
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.item_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setItemInboundDetails(response.data);
        setItemInboundDetailsModal(true);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadProductInboundDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_transfers_inbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { product_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            quantity,
          } = product_details || {};

          totalReceivingCost += Number(receiving_cost || 0);

          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.product_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductInboundDetails(response.data);
        setProductInboundDetailsModal(true);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadProductOutboundDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_transfers_outbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;

        data.forEach((item) => {
          const { product_details } = item;
          const {
            receiving_cost = 0,
            unit_levels,
            quantity,
          } = product_details || {};

          totalReceivingCost += Number(receiving_cost);

          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });

        // Get display quantity if possible
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.product_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;

          const summedQuantity = [
            {
              unit: lowestUnit,
              value: totalLowestUnitQty,
            },
          ];

          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductOutboundDetails(response.data);
        setProductOutboundDetailsModal(true);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [orderStatus, setOrderStatus] = useState("All");
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    if (allOrders.length > 0) {
      if (orderStatus === "All") {
        setFilteredOrders([...allOrders]);
      } else {
        let arr = allOrders.filter((order) => order.status === orderStatus);
        setFilteredOrders(arr);
      }
    }
  }, [allOrders, orderStatus]);

  const [purchaseModal, setPurchaseModal] = useState(false);
  const [directPurchaseModal, setDirectPurchaseModal] = useState(false);
  const [productModal, setProductModal] = useState(false);
  const [itemModal, setItemModal] = useState(false);
  const [itemOutboundModal, setItemOutboundModal] = useState(false);
  const [itemInboundModal, setItemInboundModal] = useState(false);
  const [productOutboundModal, setProductOutboundModal] = useState(false);
  const [productInboundModal, setProductInboundModal] = useState(false);

  const [filterModalTotal, setFilterModalTotal] = useState(0);

  function afterFilter(newResult, newFilters) {
    //console.log(newResult);
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0,
    );
    setFilterModalTotal(total.toFixed(2));
  }

  function afterSearch(newResult, newFilters) {
    // console.log(newResult);
    const total = newResult?.reduce((sum, order) => {
      return sum + (Number(order?.total_cost) || 0);
    }, 0);
    setGrandTotal(total.toFixed(2));
  }
  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [directPurchaseDetailsModal, setDirectPurchaseDetailsModal] =
    useState(false);
  const [productDetailsModal, setProductDetailsModal] = useState(false);
  const [itemDetailsModal, setItemDetailsModal] = useState(false);
  const [itemOutboundDetailsModal, setItemOutboundDetailsModal] =
    useState(false);
  const [itemInboundDetailsModal, setItemInboundDetailsModal] = useState(false);
  const [productOutboundDetailsModal, setProductOutboundDetailsModal] =
    useState(false);
  const [productInboundDetailsModal, setProductInboundDetailsModal] =
    useState(false);

  const columns = [
    {
      dataField: "row_number",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      formatter: (cell, row, rowIndex) => {
        return (
          <span className="mr-2">
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      sort: true,
    },

    {
      dataField: "purchase_cost",
      text: props.t("PO Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let unique = mergeDuplicateItems(row?.purchase_details);
              setSelectedRow(unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.purchase_cost);
              setPurchaseModal(true);
            }}
          >
            {row.purchase_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "direct_purchase_cost",
      text: props.t("Direct PO Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let unique = mergeDuplicateItems(row?.direct_purchase_details);
              setSelectedRow(unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.direct_purchase_cost);
              setDirectPurchaseModal(true);
            }}
          >
            {row.direct_purchase_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "item_cost",
      text: props.t("Item Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);
              setSelectedBranch(row);
              setFilterModalTotal(row.item_cost);
              setItemModal(true);
            }}
          >
            {row.item_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "product_cost",
      text: props.t("Product Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              // console.log(row);
              let unique = mergeDuplicateProducts(row?.product_details);
              setSelectedRow(unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.product_cost);
              setProductModal(true);
            }}
          >
            {row.product_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "item_outbound_transfer_cost",
      text: props.t("Item Outbound Transfer (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let filtered =
                row?.item_transfer_details.filter((ob) => ob.is_outbound) || [];
              let unique = mergeDuplicateItemsQuantity(filtered);
              setSelectedRow((prev) => (prev = unique));
              // setSelectedRow(row);
              setSelectedBranch(row);
              setFilterModalTotal(row.item_outbound_transfer_cost);
              setItemOutboundModal(true);
            }}
          >
            {row.item_outbound_transfer_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "item_inbound_transfer_cost",
      text: props.t("Item Inbound Transfer (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let filtered =
                row?.item_transfer_details.filter((ob) => ob.is_inbound) || [];
              let unique = mergeDuplicateItemsQuantity(filtered);
              setSelectedRow((prev) => (prev = unique));
              setSelectedBranch(row);
              setFilterModalTotal(row.item_inbound_transfer_cost);
              setItemInboundModal(true);
            }}
          >
            {row.item_inbound_transfer_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "product_outbound_transfer_cost",
      text: props.t("Prod. Outbound Transfer (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let filtered =
                row?.product_transfer_details.filter((ob) => ob.is_outbound) ||
                [];
              let unique = mergeDuplicateProdQuantity(filtered);
              setSelectedRow(unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.product_outbound_transfer_cost);
              setProductOutboundModal(true);
            }}
          >
            {row.product_outbound_transfer_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "product_inbound_transfer_cost",
      text: props.t("Prod. Inbound Transfer (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let filtered =
                row?.product_transfer_details.filter((ob) => ob.is_inbound) ||
                [];
              let unique = mergeDuplicateProdQuantity(filtered);
              setSelectedRow(unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.product_inbound_transfer_cost);
              setProductInboundModal(true);
            }}
          >
            {row.product_inbound_transfer_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "total_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <a href="#">{row.total_cost}</a>;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const columnsPurchase = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadPurchaseDetails(row.item_id);
            }}
          >
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Total Received"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_po;
    //     return row?.cost_price;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    // {
    //   dataField: "receiving_datetime",
    //   text: props.t("Date"),
    //   formatter: (cell, row) => {
    //     return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "11%" };
    //   },
    // },
  ];

  const columnsPurchaseDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "delivery_details.seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "delivery_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivery_details.receive);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "delivery_details.is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "delivery_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.delivery_details.cost_price + "/" + row?.delivery_details?.unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return row?.delivery_details?.free_cost_price;
        } else {
          return row?.delivery_details?.cost_price;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.delivery_details?.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_datetime",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
  ];

  const columnsDirectPurchase = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadDirectPurchaseDetails(row.item_id);
            }}
          >
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },

    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Total Received"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_po;
    //     return row?.cost_price;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    // {
    //   dataField: "receiving_datetime",
    //   text: props.t("Date"),
    //   formatter: (cell, row) => {
    //     return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "11%" };
    //   },
    // },
  ];

  const columnsDirectPurchaseDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "delivery_details.seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivery_details.receive);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "delivery_details.is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      text: props.t("Purchasing Unit"),
      dataField: "delivery_details.unit_for_po",
      sort: true,

      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivery_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.delivery_details.cost_price + "/" + row?.delivery_details?.unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return row?.delivery_details.free_cost_price;
        } else {
          return row?.delivery_details.cost_price;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.delivery_details.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "receiving_datetime",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
  ];

  const columnsProduct = [
    {
      dataField: "product_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Product"),
      dataField: "name",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadProductDetails(row.product_id);
            }}
          >
            {row.name}
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    // {
    //   text: props.t("Section"),
    //   dataField: "section",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "12%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow.product_details.map(({ section: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },

    {
      dataField: "received_quantity",
      text: props.t("Total Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_cost_price;
    //     return row?.cost_price;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
  ];

  const columnsProductDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "delivery_details.seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },

    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return row.delivery_details?.is_received
          ? formatUnitsForReport(row.delivery_details.received_quantity)
          : "Yet To Receive";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "delivery_details.unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivery_details.cost_price",
      text: props.t("Price (QR)"),
      formatter: (cell, row) => {
        return row?.delivery_details.cost_price;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "delivery_details.date_of_transaction",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.delivery_details.date_of_transaction).format(
          "DD/MM/YYYY HH:mm",
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
  ];

  const columnsItem = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadItemDetails(row.item_id);
            }}
          >
            {row.name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "received_quantity",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_po;
    //     return row?.cost_price;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const columnsItemDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "delivery_details.seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "delivery_details.category",
    //   sort: true,

    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivery_details.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "delivery_details.is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "delivery_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "delivery_details.cost_price",
    //   text: props.t("Price (QR)"),
    //   // formatter: (cell,row)=>{
    //   //   return row?.delivery_details.cost_price + "/" + row?.delivery_details?.unit_for_po
    //   //  },
    //   formatter: (cell, row) => {
    //     if (row?.delivery_details?.is_free) {
    //       return (row?.delivery_details?.free_cost_price);
    //     } else {
    //       return (row?.delivery_details?.cost_price);
    //     }
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details.projected_cost}</div>
            </div>
          );
        } else {
          return row?.delivery_details.receiving_cost;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "delivery_details.date_of_transaction",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.delivery_details.date_of_transaction).format(
          "DD/MM/YYYY HH:mm",
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
  ];

  const columnsItemOutBound = columnsItemOutbound(
    props,
    loadItemOutboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort,
    selectedBranch,
  );

  const columnsItemOutBoundDetails = columnsItemOutboundDetails(
    props,
    selectFilter,
    itemOutboundDetails,
    dynamicSort,
  );

  const columnsItemInBound = columnsItemInbound(
    props,
    loadItemInboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort,
    selectedBranch,
  );

  const columnsItemInBoundDetails = columnsItemInboundDetails(
    props,
    selectFilter,
    itemInboundDetails,
    dynamicSort,
  );

  const columnsProductInBound = columnsProductInbound(
    props,
    loadProductInboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort,
    selectedBranch,
  );

  const columnsProductInBoundDetails = columnsProductInboundDetails(
    props,
    selectFilter,
    productInboundDetails,
    dynamicSort,
  );

  const columnsProductOutBound = columnsProductOutbound(
    props,
    loadProductOutboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort,
    selectedBranch,
  );

  const columnsProductOutBoundDetails = columnsProductOutboundDetails(
    props,
    selectFilter,
    productOutboundDetails,
    dynamicSort,
  );

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const handleDownload = async () => {
    const fileName = "branchwise_summary_report";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          PurchaseCost: v.purchase_cost,
          ProductCost: v.product_cost,
          DirectCost: v.direct_purchase_cost,
          ItemCost: v.item_cost,
          TotalCost: v.total_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branchwise Summary Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branchwise Summary Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoading}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {isLoading && (
                    <div className="mb-3">
                      <Progress
                        animated
                        color="info"
                        value={progress}
                        style={{
                          height: "20px",
                          color: "Highlight",
                          fontWeight: "bold",
                        }}
                      >
                        {Math.round(progress)}% Loading...
                      </Progress>
                    </div>
                  )}

                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv0");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv0">
                    <CardTitle className="text-center">
                      {props.t("Branchwise Summary Report")}
                      <br />
                      <h6>
                        (Total Cost : Cost of items from po created by CSM +
                        cost of items from direct po by branches + Cost of items
                        ordered from central store + cost of items ordered from
                        central kitchen.)
                      </h6>
                    </CardTitle>

                    <ToolkitProvider
                      keyField="_id"
                      data={filteredOrders && filteredOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                placeholder="Search here... "
                                onSearch={(searchText) => {
                                  toolkitProps.searchProps.onSearch(searchText);
                                  const data =
                                    toolkitProps.baseProps.data || [];
                                  if (!searchText || searchText.trim() === "") {
                                    afterSearch(data);
                                    return;
                                  }
                                  const q = searchText.toLowerCase();
                                  afterSearch(
                                    data.filter((row) =>
                                      String(row.name || "")
                                        .toLowerCase()
                                        .includes(q),
                                    ),
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}>
                              <h5>
                                {" "}
                                Grand Total : QR{" "}
                                {grandTotal.toLocaleString("en-QA", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            noDataIndication={
                              isLoading ? (
                                <Spinner size={"md"} />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(pagination_options)}
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* Purchase breakup modal       */}
          <Modal
            size="xl"
            isOpen={purchaseModal}
            toggle={() => setPurchaseModal(!purchaseModal)}
          >
            <ModalHeader toggle={() => setPurchaseModal(!purchaseModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>
                    </Col>
                    <Col lg={4}></Col>
                  </Row>

                  <CardTitle className="text-center">
                    {props.t("(Purchase Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>

                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsPurchase}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivPurchaseitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("Purchase Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Purchase Item Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnsPurchaseDetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "receive",
                                    "delivery_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            zcondensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Direct Purchase breakup modal       */}
          <Modal
            size="xl"
            isOpen={directPurchaseModal}
            toggle={() => setDirectPurchaseModal(!directPurchaseModal)}
          >
            <ModalHeader
              toggle={() => setDirectPurchaseModal(!directPurchaseModal)}
            >
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv2");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv2">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <Row>
                            <Col lg={4}>
                              <img
                                src={logo}
                                alt=""
                                height="50"
                                style={{ borderRadius: "5px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle className="text-center">
                                {props.t("Branchwise Summary Report")}
                              </CardTitle>
                            </Col>
                            <Col lg={4}></Col>
                          </Row>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("(Direct Purchase Details)")}
                          </CardTitle>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsDirectPurchase}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Direct Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={directPurchaseDetailsModal}
            toggle={() =>
              setDirectPurchaseDetailsModal(!directPurchaseDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setDirectPurchaseDetailsModal(!directPurchaseDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivDirectPurchase");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivDirectPurchase">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Direct Purchase Details")}{" "}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Direct Purchase Item Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              directPurchaseDetails && directPurchaseDetails
                            }
                            columns={columnsDirectPurchaseDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "receive",
                                    "delivery_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Product breakup modal       */}
          <Modal
            size="xl"
            isOpen={productModal}
            toggle={() => setProductModal(!productModal)}
          >
            <ModalHeader toggle={() => setProductModal(!productModal)}>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv3");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv3">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <Row>
                            <Col lg={4}>
                              <img
                                src={logo}
                                alt=""
                                height="50"
                                style={{ borderRadius: "5px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle className="text-center">
                                {props.t("Branchwise Summary Report")}
                              </CardTitle>
                            </Col>
                            <Col lg={4}></Col>
                          </Row>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("(Product Details)")}
                          </CardTitle>
                          <h5>
                            Branch : {selectedBranch?.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProduct}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productDetailsModal}
            toggle={() => setProductDetailsModal(!productDetailsModal)}
          >
            <ModalHeader
              toggle={() => setProductDetailsModal(!productDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProduct");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProduct">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={productDetails && productDetails}
                            columns={columnsProductDetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "received_quantity",
                                    "delivery_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Item breakup modal       */}
          <Modal
            size="xl"
            isOpen={itemModal}
            toggle={() => setItemModal(!itemModal)}
          >
            <ModalHeader toggle={() => setItemModal(!itemModal)}>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv4");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv4">
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <Row>
                            <Col lg={4}>
                              <img
                                src={logo}
                                alt=""
                                height="50"
                                style={{ borderRadius: "5px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle className="text-center">
                                {props.t("Branchwise Summary Report")}
                              </CardTitle>
                            </Col>
                            <Col lg={4}></Col>
                          </Row>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("(Item Details)")}
                          </CardTitle>
                          <h5>
                            Branch : {selectedRow.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              selectedRow.item_details &&
                              selectedRow.item_details
                            }
                            columns={columnsItem}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item breakup details modal       */}
          <Modal
            size="xl"
            isOpen={itemDetailsModal}
            toggle={() => setItemDetailsModal(!itemDetailsModal)}
          >
            <ModalHeader toggle={() => setItemDetailsModal(!itemDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={itemDetails && itemDetails}
                            columns={columnsItemDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "received_quantity",
                                    "delivery_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Outbound modal       */}
          <Modal
            size="xl"
            isOpen={itemOutboundModal}
            toggle={() => setItemOutboundModal(!itemOutboundModal)}
          >
            <ModalHeader
              toggle={() => setItemOutboundModal(!itemOutboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemOutbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemOutbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Item Outbound Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsItemOutBound}
                            striped
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Outbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={itemOutboundDetailsModal}
            toggle={() =>
              setItemOutboundDetailsModal(!itemOutboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setItemOutboundDetailsModal(!itemOutboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemOutbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemOutbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Outbound")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Outbound Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={itemOutboundDetails && itemOutboundDetails}
                            columns={columnsItemOutBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "quantity",
                                    "item_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Inbound modal       */}
          <Modal
            size="xl"
            isOpen={itemInboundModal}
            toggle={() => setItemInboundModal(!itemInboundModal)}
          >
            <ModalHeader toggle={() => setItemInboundModal(!itemInboundModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemInbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemInbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Item Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsItemInBound}
                            striped
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Inbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={itemInboundDetailsModal}
            toggle={() => setItemInboundDetailsModal(!itemInboundDetailsModal)}
          >
            <ModalHeader
              toggle={() =>
                setItemInboundDetailsModal(!itemInboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemInbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemInbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Inbound Transfer")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={itemInboundDetails && itemInboundDetails}
                            columns={columnsItemInBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "quantity",
                                    "item_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Outbound modal       */}
          <Modal
            size="xl"
            isOpen={productOutboundModal}
            toggle={() => setProductOutboundModal(!productOutboundModal)}
          >
            <ModalHeader
              toggle={() => setProductOutboundModal(!productOutboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProdOutbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProdOutbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Product Outbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProductOutBound}
                            striped
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product outbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productOutboundDetailsModal}
            toggle={() =>
              setProductOutboundDetailsModal(!productOutboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setProductOutboundDetailsModal(!productOutboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiviProdOutbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiviProdOutbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Transfer Outbound")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Outbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              productOutboundDetails && productOutboundDetails
                            }
                            columns={columnsProductOutBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "quantity",
                                    "product_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Inbound modal       */}
          <Modal
            size="xl"
            isOpen={productInboundModal}
            toggle={() => setProductInboundModal(!productInboundModal)}
          >
            <ModalHeader
              toggle={() => setProductInboundModal(!productInboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProdInbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProdInbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Product Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString("en-QA", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProductInBound}
                            striped
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Inbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productInboundDetailsModal}
            toggle={() =>
              setProductInboundDetailsModal(!productInboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setProductInboundDetailsModal(!productInboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiviProdInbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiviProdInbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Inbound Transfer")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h5 className="mb-0">
                                Branch: {selectedBranch.name}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total Qty:{" "}
                                {formatUnitsForReport(filterModalTotalQty)}
                              </h5>
                            </div>
                            <div>
                              <h5 className="mb-0">
                                Total:{" "}
                                {Number(filterModalSubTotal).toLocaleString(
                                  "en-QA",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </h5>
                            </div>
                          </div>
                          <BootstrapTable
                            keyField="_id"
                            data={
                              productInboundDetails && productInboundDetails
                            }
                            columns={columnsProductInBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(
                                    newResult,
                                    "quantity",
                                    "product_details",
                                  );
                                }, 200);
                                return newResult;
                              },
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(BranchwiseSummaryReport)),
);
